import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Input,
  SvgIcon,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Typography,
} from '@mui/material';
import { Search as SearchIcon } from 'react-feather';

const Search = forwardRef(
  (
    {
      className,
      isFocused = false,
      onChange,
      onSelect,
      query = '',
      placeholder,
      resultLabel,
      results = [],
      ...rest
    },
    ref
  ) => {
    const displayResults = query && isFocused;

    const handleSelect = (result) => {
      if (onSelect) {
        onSelect(result);
      }
    };

    return (
      <Box
        className={className}
        ref={ref}
        sx={{ pl: 1, pr: 1 }}
        {...rest}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: 44,
            borderRadius: '22px',
            pl: 2,
            pr: 2,
            backgroundColor: 'background.dark',
          }}
        >
          <SvgIcon fontSize="small" color="action">
            <SearchIcon />
          </SvgIcon>
          <Input
            sx={{ flexGrow: 1, ml: 1 }}
            disableUnderline
            onChange={onChange}
            placeholder={placeholder}
            value={query}
          />
        </Box>
        {displayResults && (
          <Box mt={2}>
            <Typography variant="h6" color="textSecondary">
              {resultLabel}
            </Typography>
            <List>
              {results.map((result) => {
                return (
                  <ListItem
                    button
                    key={result.id}
                    onClick={() => handleSelect(result)}
                  >
                    <ListItemAvatar>
                      <Avatar
                        src={result.avatar}
                        sx={{ height: 32, width: 32 }}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={result.name}
                      primaryTypographyProps={{
                        noWrap: true,
                        variant: 'h6',
                        color: 'textPrimary',
                      }}
                    />
                  </ListItem>
                );
              })}
            </List>
          </Box>
        )}
      </Box>
    );
  }
);

Search.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  query: PropTypes.string,
  placeholder: PropTypes.string,
  resultLabel: PropTypes.string,
  results: PropTypes.array,
};

export default Search;
